import { useLocation, useNavigate } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  Col,
  Empty,
  Row,
  Skeleton,
  Statistic,
  Typography,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import { getEntity } from "../../../controllers/entities";
import "./Capacities.scss";
import { UserOutlined } from "@ant-design/icons";
import { capitalizeString } from "../../../shared/util";
import Moment from "react-moment";
import { Contact, DataItem, routerData } from "../..";
import { useSelector } from "react-redux";
import useRecomendationsCapacities from "../../../hooks/recomendations-capacities-hook";
import RecomendationCapacitiesList from "../../components/RecomendationsCapacities";
const formatter = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "COP", // Cambia a 'USD', 'COP', etc., según la moneda que necesites.
});
const CapacityDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { param, type } = location.state;
  const [groups, setGroups] = useState({} as any);
  const [entity, setEntity] = useState({} as any);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const { result, getRecomendationsCapacities } = useRecomendationsCapacities();
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [searchersLoading, setSearchersLoading] = useState(false);
  const [searchers, setSearchers] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contact, setContact] = useState<Contact>();
  const user = useSelector((state: any) => {
    return state.user.user;
  });
  const go = (params: routerData, entity: any) => {
    navigate(`/${entity}/${params.id}`, { state: { params, entity } });
  };

  useEffect(() => {
    const getentity = async () => {
      setLoading(true);
      const id = param?.products_id?.id || param?.id;
      const entitie = await getEntity(id, type);
      setEntity(entitie);
      setLoading(false);
    };

    getRecomendationsCapacities("all", { filter: "" }, 1, 5);
    getentity();
  }, []);

  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <Skeleton loading={loading} active className="full-width">
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={8} lg={16}>
            {type === "commons_capacities" ? (
              <div>
                <h1 className="conection-heading-section">Datos generales</h1>
                <Card
                  className="ant-card-conection ant-card-conection-bordered"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row
                    gutter={[8, 8]}
                    style={{ width: "100%", marginBottom: 20 }}
                  >
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Nombre</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.nombre ||
                            entity.institution_name ||
                            entity?.nombre ||
                            entity.NOMBRE
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Descripción</h2>
                      <p className="conection-value text-justify">
                        {capitalizeString(
                          entity.descripcion ||
                            entity.DESCRIPCION ||
                            "Sin descripcion"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Descripción detallada</h2>
                      <p className="conection-value text-justify">
                        {capitalizeString(
                          entity.descripcion_detallada || "Sin descripcion"
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Especialidad del conocimiento
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.especialidad_de_conocimiento
                            ?.ESPECIALIDAD_DE_CONOCIMIENTO || ""
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Area de conocimiento</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity?.area_de_conocimiento?.AREA_DE_CONOCIMIENTO ||
                            ""
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Gran área de conocimiento
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity?.gran_area_de_conocimiento
                            ?.GRAN_AREA_DE_CONOCIMIENTO || ""
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Problema que soluciona
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity?.problemas_que_soluciona || ""
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Beneficios que genera</h2>
                      <p className="conection-value">
                        {capitalizeString(entity?.beneficios_que_genera || "")}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Grado de madurez de la solución
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity?.grado_de_madurez_de_la_solucion_capacidad ||
                            ""
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Beneficiario</h2>
                      <p className="conection-value">
                        {capitalizeString(entity?.beneficiario || "")}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Identidad</h2>
                      <p className="conection-value">
                        {capitalizeString(entity?.identidad || "")}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Presupuesto</h2>
                      <p className="conection-value">
                        {
                          <Statistic
                            className="connection-value"
                            value={formatter.format(
                              parseInt(entity.presupuesto || 0)
                            )}
                            precision={2}
                          />
                        }
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {entity.url ? (
                      <Col xs={24} sm={12} md={8} lg={12}>
                        <h2 className="conection-label">URL</h2>
                        {entity?.url ? (
                          <Button
                            type="primary"
                            onClick={() => {
                              window.open(entity?.url, "_blank");
                            }}
                          >
                            Abrir URL
                          </Button>
                        ) : (
                          "Sin url"
                        )}
                      </Col>
                    ) : null}
                  </Row>
                </Card>
                {searchers.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">
                      Investigadores
                    </h1>
                    <Skeleton
                      loading={searchersLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-bordered"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          {searchers.map((s: any) => (
                            <Col span={12} key={s.id}>
                              <li
                                onClick={() => {
                                  go(
                                    {
                                      id: s.searchers_id.id,
                                      name: s.searchers_id.nombre,
                                      type: s.searchers_id.actor_type.actor,
                                    },
                                    "searchers"
                                  );
                                }}
                                style={{ marginBottom: 20 }}
                                className="flex with-pointer"
                              >
                                <Avatar icon={<UserOutlined />} />
                                <p className="profile-info">
                                  {`${s?.searchers_id?.nombre}` || ""}
                                  <span>
                                    {`${s?.searchers_id?.nme_niv_form_pr}` ||
                                      ""}
                                  </span>
                                </p>
                              </li>
                            </Col>
                          ))}
                        </Row>
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
              </div>
            ) : null}
            {type === "projects" ? (
              <div>
                <h1 className="conection-heading-section">Datos generales</h1>
                <Card
                  className="ant-card-conection ant-card-conection-bordered"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row
                    gutter={[8, 8]}
                    style={{ width: "100%", marginBottom: 20 }}
                  >
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Titulo del proyecto</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.titulo_proyecto || "")}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label text-justify">
                        Descripción
                      </h2>
                      <p className="conection-value text-justify">
                        {capitalizeString(entity.descripcion || "No informa")}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label text-justify">
                        Descripción detallada
                      </h2>
                      <p className="conection-value text-justify">
                        {capitalizeString(
                          entity.descripcion_detallada || "No informa"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Tipo de proyecto</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.tipo_proyecto || "No informa")}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Area de conocimiento</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.area_de_conocimiento?.AREA_DE_CONOCIMIENTO ||
                            "No informa"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">
                        Gran area de conocimiento
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.gran_area_de_conocimiento
                            ?.GRAN_AREA_DE_CONOCIMIENTO || "No informa"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Aliados del proyecto</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.aliados_del_proyecto || "No informa"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Tiempo de ejecución</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.tiempo_de_ejecucion_estimado || "No informa"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Estado del proyecto</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.estado_proyecto?.estado || "No informa"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Especialidad</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.especialidad_de_conocimiento
                            ?.ESPECIALIDAD_DE_CONOCIMIENTO || "No informa"
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Presupuesto estimado</h2>
                      <p className="conection-value">
                        {
                          <Statistic
                            className="connection-value"
                            value={formatter.format(
                              parseInt(entity.presupuesto_estimado || 0)
                            )}
                            precision={2}
                          />
                        }
                      </p>
                    </Col>
                  </Row>
                </Card>
                {entity.products && entity.products.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">Productos</h1>
                    <Card
                      className="ant-card-conection ant-card-conection-bordered"
                      onClick={() => {}}
                      hoverable
                      style={{ width: "100%", marginBottom: 30 }}
                    >
                      <Row gutter={[8, 8]} style={{ width: "100%" }}>
                        {entity.products.map((product: any) => {
                          return (
                            <Col xs={24} sm={12} md={8} lg={12}>
                              <Button
                                className="connection-font"
                                block
                                size="middle"
                                onClick={() => {
                                  go(
                                    {
                                      id: product.products_id?.id,
                                      name: product.products_id
                                        ?.nme_producto_pd,
                                      type: product.products_id?.actor_type
                                        ?.actor,
                                    },
                                    "products"
                                  );
                                }}
                                style={{
                                  marginBottom: 10,
                                  marginRight: 20,
                                  height: "auto",
                                }}
                              >
                                {capitalizeString(
                                  product.products_id?.nme_producto_pd
                                )}
                              </Button>
                            </Col>
                          );
                        })}
                      </Row>
                    </Card>
                  </>
                ) : null}
              </div>
            ) : null}
            {type === "products" ? (
              <div>
                <h1 className="conection-heading-section">Datos generales</h1>
                <Card
                  className="ant-card-conection ant-card-conection-bordered"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row
                    gutter={[8, 8]}
                    style={{ width: "100%", marginBottom: 20 }}
                  >
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Producto</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.nme_producto_pd)}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Capacidad</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.capacity_type?.capacities || "Sin descripcion"
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Tipología</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.nme_tipologia_pd)}
                      </p>
                    </Col>
                  </Row>
                </Card>
                {entity.university ? (
                  <>
                    <h1 className="conection-heading-section">
                      Institución (IES)
                    </h1>
                    <Skeleton
                      loading={searchersLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection aant-card-conection-bordered"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          <Col xs={24} sm={12} md={8} lg={12}>
                            <Button
                              className="connection-font"
                              size="middle"
                              onClick={() => {
                                go(
                                  {
                                    id: entity.university?.id,
                                    name: entity.university?.institution_name,
                                    type: entity.university?.actor_type?.actor,
                                  },
                                  "universities"
                                );
                              }}
                              style={{
                                marginBottom: 10,
                                marginRight: 20,
                                width: "auto",
                              }}
                            >
                              {capitalizeString(
                                entity.university?.institution_name
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
                {entity.group ? (
                  <>
                    <h1 className="conection-heading-section">Grupo</h1>
                    <Skeleton
                      loading={searchersLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-bordered"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          <Col xs={24} sm={12} md={8} lg={12}>
                            <Button
                              className="connection-font"
                              size="middle"
                              onClick={() => {
                                go(
                                  {
                                    id: entity.group?.id,
                                    name: entity.group?.nme_grupo_gr,
                                    type: entity.group?.actor_type?.actor,
                                  },
                                  "groups"
                                );
                              }}
                              style={{
                                marginBottom: 10,
                                marginRight: 20,
                                width: "auto",
                              }}
                            >
                              {capitalizeString(entity.group?.nme_grupo_gr)}
                            </Button>
                          </Col>
                        </Row>
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
                <>
                  <h1 className="conection-heading-section">Investigadores</h1>
                  <Card
                    className="ant-card-conection ant-card-conection-border"
                    onClick={() => {}}
                    hoverable
                    style={{ width: "100%", marginBottom: 30 }}
                  >
                    <Row gutter={[8, 8]} className="full-width">
                      <Col xs={24} sm={12} md={8} lg={24}>
                        {!entity?.searchers ||
                        entity.searchers?.length === 0 ? (
                          <Empty description={"0 Registros"} />
                        ) : null}
                      </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                      {entity?.searchers?.map((s: any) => (
                        <Col lg={12} key={s.id}>
                          <div
                            onClick={() => {
                              go(
                                {
                                  id: s.searchers_id.id,
                                  name: s.searchers_id.nombre,
                                  type: s.searchers_id.actor_type.actor,
                                },
                                "searchers"
                              );
                            }}
                            style={{ marginBottom: 20 }}
                            className="flex with-pointer"
                          >
                            <Avatar icon={<UserOutlined />} />
                            <p className="profile-info">
                              {`${s?.searchers_id?.nombre}` || ""}
                              <span>
                                {`${s?.searchers_id?.nme_niv_form_pr}` || ""}
                              </span>
                            </p>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    <Row />
                  </Card>
                  {entity?.universities?.length > 0 ? (
                    <>
                      <h1 className="conection-heading-section">
                        Instituciones
                      </h1>
                      <Card
                        className="ant-card-conection ant-card-conection-border"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          {entity?.universities.map((g: any) => {
                            return (
                              <Col xs={24} sm={12} md={8} lg={12}>
                                <Button
                                  className="connection-font"
                                  size="middle"
                                  onClick={() => {
                                    console.log("args", {
                                      id: g.universities_id.id,
                                      name: g.universities_id.institution_name,
                                      type: g.universities_id.actor_type.actor,
                                    });
                                    go(
                                      {
                                        id: g.universities_id.id,
                                        name: g.universities_id
                                          .institution_name,
                                        type: g.universities_id.actor_type
                                          .actor,
                                      },
                                      "universities"
                                    );
                                  }}
                                  style={{
                                    marginBottom: 10,
                                    marginRight: 20,
                                    width: 450,
                                  }}
                                >
                                  {capitalizeString(
                                    g.universities_id?.institution_name || ""
                                  )}
                                </Button>
                              </Col>
                            );
                          })}
                        </Row>
                      </Card>
                    </>
                  ) : null}
                  {entity?.groups?.length > 0 ? (
                    <>
                      <h1 className="conection-heading-section">Grupos</h1>
                      <Card
                        className="ant-card-conection ant-card-conection-border"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} className="full-width">
                          <Col xs={24} sm={12} md={8} lg={24}>
                            {!entity?.groups || entity?.groups?.length === 0 ? (
                              <Empty description={"0 Registros"} />
                            ) : null}
                          </Col>
                        </Row>
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          {entity.groups?.map((g: any) => {
                            return (
                              <Col xs={24} sm={12} md={8} lg={12}>
                                <Button
                                  block
                                  style={{
                                    whiteSpace: "normal",
                                    height: "auto",
                                    marginBottom: "10px",
                                  }}
                                  className="connection-font"
                                  size="middle"
                                  onClick={() => {
                                    go(
                                      {
                                        id: g.groups_id.id,
                                        name: g.groups_id.nme_grupo_gr,
                                        type: g.groups_id.actor_type.actor,
                                      },
                                      "groups"
                                    );
                                  }}
                                >
                                  {capitalizeString(g.groups_id.nme_grupo_gr)}
                                </Button>
                              </Col>
                            );
                          })}
                        </Row>
                      </Card>
                    </>
                  ) : null}
                </>
              </div>
            ) : null}
            {type === "universities" ? (
              <div>
                <h1 className="conection-heading-section">Datos generales</h1>
                <Card
                  className="ant-card-conection ant-card-conection-bordered"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Nombre</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.institution_name)}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Departamento</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.state)}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Ciudad</h2>
                      <p className="conection-value">
                        {capitalizeString(entity?.municipality)}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Institución acreditada?
                      </h2>
                      <p className="conection-value">
                        {entity.is_accredited === 1 ? "Si" : "No"}
                      </p>
                    </Col>
                    {entity?.update_date ? (
                      <Col xs={24} sm={12} md={8} lg={12}>
                        <h2 className="conection-label">
                          Última actualización
                        </h2>
                        <p className="conection-value">
                          <Moment format="DD/MM/YYYY">
                            {entity?.update_date || "sin definir"}
                          </Moment>
                        </p>
                      </Col>
                    ) : null}

                    {entity?.source ? (
                      <Col xs={24} sm={12} md={8} lg={12}>
                        <h2 className="conection-label">Fuente</h2>
                        <p className="conection-value">
                          {capitalizeString(entity?.source || "sin definir")}
                        </p>
                      </Col>
                    ) : null}
                    {entity.recognize_min ? (
                      <Col xs={24} sm={12} md={8} lg={12}>
                        <h2 className="conection-label">
                          Reconociento Minciencias (Sí/No){" "}
                        </h2>
                        <p className="conection-value">
                          {entity?.recognized_min === "1" ? "Si" : "No"}
                        </p>
                      </Col>
                    ) : null}
                    {entity.features ? (
                      <Col xs={24} sm={12} md={8} lg={12}>
                        <h2 className="conection-label">Características</h2>
                        <p className="conection-value">
                          {capitalizeString(entity?.features || "sin definir")}
                        </p>
                      </Col>
                    ) : null}
                  </Row>
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {entity.url ? (
                      <Col xs={24} sm={12} md={8} lg={12}>
                        <h2 className="conection-label">URL</h2>
                        {entity?.url ? (
                          <Button
                            type="primary"
                            onClick={() => {
                              window.open(entity?.url, "_blank");
                            }}
                          >
                            Abrir URL
                          </Button>
                        ) : (
                          "Sin url"
                        )}
                      </Col>
                    ) : null}
                  </Row>
                </Card>
                {groups.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">Proyectos</h1>
                    <Skeleton
                      loading={groupsLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-bordered "
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          {groups.map((g: any) => {
                            return (
                              <Col xs={24} sm={12} md={8} lg={12}>
                                <Button
                                  size="middle"
                                  onClick={() => {
                                    go(
                                      {
                                        id: g?.id,
                                        name: g.groups_id?.nme_grupo_gr,
                                        type: g?.groups_id?.actor_type?.actor,
                                      },
                                      "groups"
                                    );
                                  }}
                                  style={{
                                    marginBottom: 10,
                                    marginRight: 20,
                                    width: "auto",
                                  }}
                                >
                                  {capitalizeString(g.groups_id.nme_grupo_gr)}
                                </Button>
                              </Col>
                            );
                          })}
                        </Row>
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
                {groups.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">Grupos</h1>
                    <Skeleton
                      loading={groupsLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-bordered "
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          {groups.map((g: any) => {
                            return (
                              <Col xs={24} sm={12} md={8} lg={12}>
                                <Button
                                  size="middle"
                                  onClick={() => {
                                    go(
                                      {
                                        id: g?.id,
                                        name: g.groups_id?.nme_grupo_gr,
                                        type: g?.groups_id?.actor_type?.actor,
                                      },
                                      "groups"
                                    );
                                  }}
                                  style={{
                                    marginBottom: 10,
                                    marginRight: 20,
                                    width: "auto",
                                  }}
                                >
                                  {capitalizeString(g.groups_id.nme_grupo_gr)}
                                </Button>
                              </Col>
                            );
                          })}
                        </Row>
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
                {searchers.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">
                      Investigadores
                    </h1>
                    <Skeleton
                      loading={groupsLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-bordered"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}></Row>
                        {searchers.map((s: any) => (
                          <Col span={12} key={s.id}>
                            <li>
                              <li
                                onClick={() => {
                                  go(
                                    {
                                      id: s.searchers_id?.id,
                                      name: s.searchers_id?.nombre,
                                      type: s.searchers_id?.actor_type?.actor,
                                    },
                                    "searchers"
                                  );
                                }}
                                style={{ marginBottom: 20 }}
                                className="flex with-pointer"
                              >
                                <Avatar icon={<UserOutlined />} />
                                <p className="profile-info">
                                  {`${s?.searchers_id?.nombre}` || ""}
                                  <span>
                                    {`${s?.searchers_id?.nme_niv_form_pr}` ||
                                      ""}
                                  </span>
                                </p>
                              </li>
                            </li>
                          </Col>
                        ))}
                        <Row />
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
              </div>
            ) : null}
            {type === "searchers" ? (
              <div>
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2>Nombre</h2>
                    {capitalizeString(entity?.nombre || "sin definir")}
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2>Filiación institucional</h2>
                    {capitalizeString(entity.inst_filia || "sin definir")}
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2>Nivel de formación</h2>
                    <p>
                      <strong>
                        {capitalizeString(entity?.nme_niv_form_pr)}
                      </strong>{" "}
                    </p>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2>Gran área de conocimiento</h2>
                    <p>
                      {capitalizeString(
                        entity?.nme_gran_area_pr || "sin definir"
                      )}
                    </p>
                  </Col>
                </Row>

                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2>Área de conocimiento</h2>
                    <p>{entity?.nme_area_pr || ""}</p>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2>Espacialidad del conocimiento</h2>
                    <p>
                      {capitalizeString(
                        entity?.nme_esp_area_pr || "sin definir"
                      )}
                    </p>
                  </Col>
                </Row>
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  {entity?.update_date ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">
                        Última de actualización
                      </h2>
                      <p className="conection-value">
                        {entity?.update_date || "sin definir"}
                      </p>
                    </Col>
                  ) : null}
                  {entity?.source ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2>Fuente</h2>
                      <p>{capitalizeString(entity?.source || "sin definir")}</p>
                    </Col>
                  ) : null}
                  {entity.recognize_min ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2>Reconociento Minciencias (Sí/No) </h2>
                      <p>{entity?.recognized_min === "1" ? "Si" : "No"}</p>
                    </Col>
                  ) : null}
                  {entity.features ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2>Características |</h2>
                      <p>
                        {capitalizeString(entity?.features || "sin definir")}
                      </p>
                    </Col>
                  ) : null}
                </Row>
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  {entity.enlace_cvlac ? (
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2>URL</h2>
                      {entity?.enlace_cvlac ? (
                        <Button
                          type="primary"
                          onClick={() => {
                            window.open(entity?.enlace_cvlac, "_blank");
                          }}
                        >
                          Abrir CVLAC
                        </Button>
                      ) : (
                        "Sin url"
                      )}
                    </Col>
                  ) : null}
                </Row>
              </div>
            ) : null}
          </Col>
          {user?.me ? (
            <Col xs={24} sm={12} md={8} lg={8}>
              <h1 className="conection-heading-section">Sugerencias</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <RecomendationCapacitiesList
                  totalPages={result.pagination?.total}
                  onPaginationChanged={(page) => {
                    getRecomendationsCapacities("all", { filter: {} }, page, 5);
                    setPage(page);
                  }}
                  onConnect={(contact) => {
                    setContact({
                      name: contact.title,
                      type: contact.description,
                      email: contact.contact_email,
                    });
                    setIsModalOpen(!isModalOpen);
                  }}
                  data={result.values
                    .filter((r) => r.id !== param?.id)
                    .map((recomendation: any) => {
                      console.log("recomendation", recomendation);
                      return {
                        title: recomendation.name,
                        description: `${recomendation.type} - ${recomendation.typology}`,
                        avatar: "",
                        contact_email: recomendation.contact_email,
                      } as DataItem;
                    })}
                />
              </Card>
            </Col>
          ) : null}
        </Row>
      </Skeleton>
    </div>
  );
};

export default CapacityDetail;
